import { render } from "./UserManual.vue?vue&type=template&id=7ba23584&scoped=true"
const script = {}

import "@/assets/styles/text-page.scss?vue&type=style&index=0&id=7ba23584&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ba23584"

export default script